var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 485,
    viewBox: "0 0 494 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_2306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.263 245.487L383.548 225.719C383.548 225.719 366.682 226.26 381.102 198.526L404.051 207.507L399.581 224.445L400.919 245.632L382.263 245.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.263 245.487L383.548 225.719C383.548 225.719 366.682 226.26 381.102 198.526L404.051 207.507L399.581 224.445L400.919 245.632L382.263 245.487Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.612 209.746C392.612 209.746 395.33 205.31 398.086 208.519C399.254 209.883 399.119 213.447 394.426 214.684C394.426 214.684 393.14 222.684 401.347 224C401.347 224 412.402 214.451 409.63 202.624C409.63 202.624 423.613 207.06 426.783 194.508C427.735 190.739 425.733 183.342 417.256 182.115C413.058 181.507 405.206 183.046 404.388 192.986C404.388 192.986 387.257 181.957 378 199.621C378 199.621 383.807 208.852 392.612 209.751V209.746Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.775 447.737C252.775 447.737 268.907 468.019 281.917 465.419L283.478 461.259L259.02 445.137L252.775 447.737Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.587 315.643C356.587 315.643 399.519 343.726 420.855 333.325L415.651 318.763L366.214 308.362L356.587 315.643Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.063 454.498C426.063 454.498 441.675 446.177 441.155 421.734L433.349 417.054L419.819 447.217L426.063 454.498Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.123 154.581C169.123 154.581 130.645 154.586 107.467 167.125L145.32 212.791C161.957 192.368 169.123 154.586 169.123 154.586V154.581Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.931 441.964C258.931 441.964 256.699 456.807 246.197 459.875C240.078 461.664 224.065 464.452 220.324 472.7L267.965 472.632L277.754 452.938L258.931 441.964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.931 441.964C258.931 441.964 256.699 456.807 246.197 459.875C240.078 461.664 224.065 464.452 220.324 472.7L267.965 472.632L277.754 452.938L258.931 441.964V441.964Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.681 427.455L450.329 436.15L451.568 472.44H429.285C429.285 472.44 432.584 466.256 437.949 465.429C437.949 465.429 434.281 448.694 423.457 442.578L428.681 427.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.681 427.455L450.329 436.15L451.568 472.44H429.285C429.285 472.44 432.584 466.256 437.949 465.429C437.949 465.429 434.281 448.694 423.457 442.578L428.681 427.455V427.455Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.056 308.362L360.073 390.099C359.85 399.346 364.096 408.14 371.48 413.715L425.809 454.753C425.809 454.753 426.069 443.051 429.191 435.771C432.433 428.214 440.379 421.469 440.379 421.469L394.065 382.985L408.001 316.938L362.061 308.357L362.056 308.362Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.194 312.782L407.33 316.683C407.33 316.683 410.972 323.963 347.485 381.69L281.917 465.419C281.917 465.419 276.713 455.538 268.907 451.897C262.355 448.845 252.775 447.737 252.775 447.737L306.609 371.465C308.534 368.74 310.621 366.135 312.869 363.67L359.194 312.782Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.532 235.746L324.801 235.289L285.33 221.804L281.979 219.037C280.22 217.586 278.196 216.489 276.015 215.812L264.223 212.156L280.876 229.838L319.473 249.944C322.668 251.608 326.154 252.633 329.74 252.96L342.833 254.156L341.532 235.757V235.746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.532 235.746L324.801 235.289L285.33 221.804L281.979 219.037C280.22 217.586 278.196 216.489 276.015 215.812L264.223 212.156L280.876 229.838L319.473 249.944C322.668 251.608 326.154 252.633 329.74 252.96L342.833 254.156L341.532 235.757V235.746Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.056 261.037C362.056 261.037 361.759 278.032 362.056 282.359C363.097 297.441 354.51 316.943 354.51 316.943C354.51 316.943 371.943 316.163 387.035 319.803C403.999 323.896 419.819 331.764 419.819 331.764L420.053 254.765C420.069 249.382 417.54 244.312 413.236 241.082L401.345 232.168C401.345 232.168 385.994 249.59 381.571 233.208L338.378 235.289L339.679 259.991L362.056 261.031V261.037Z",
    fill: "#FABA36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.056 261.037C362.056 261.037 361.759 278.032 362.056 282.359C363.097 297.441 354.51 316.943 354.51 316.943C354.51 316.943 371.943 316.163 387.035 319.803C403.999 323.896 419.819 331.764 419.819 331.764L420.053 254.765C420.069 249.382 417.54 244.312 413.236 241.082L401.345 232.168C401.345 232.168 385.994 249.59 381.571 233.208L338.378 235.289L339.679 259.991L362.056 261.031V261.037Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.056 261.037L361.593 247.474",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.852 164.743L126.571 119.311L151.097 21.1707",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.172 20.3177C166.172 20.3177 196.323 132.25 264.822 212.786C264.822 212.786 322.98 284.179 395.59 294.159C466.924 303.967 465.118 366.593 465.118 366.593",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.417 282.619L344.915 272.285L321.726 264.417L330.692 274.901C332.821 277.387 335.636 279.192 338.784 280.076L344.098 281.574L395.829 302.163C400.934 304.196 406.664 301.237 407.954 295.896L413.309 273.768L391.973 269.087L390.412 282.609L390.417 282.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.417 282.619L344.915 272.285L321.726 264.417L330.692 274.901C332.821 277.387 335.636 279.192 338.784 280.076L344.098 281.574L395.829 302.163C400.934 304.196 406.664 301.237 407.954 295.896L413.309 273.768L391.973 269.087L390.412 282.609L390.417 282.619Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.585 28.5711C162.896 28.5711 166.391 25.0785 166.391 20.7702C166.391 16.4619 162.896 12.9694 158.585 12.9694C154.274 12.9694 150.779 16.4619 150.779 20.7702C150.779 25.0785 154.274 28.5711 158.585 28.5711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.585 28.5711C162.896 28.5711 166.391 25.0785 166.391 20.7702C166.391 16.4619 162.896 12.9694 158.585 12.9694C154.274 12.9694 150.779 16.4619 150.779 20.7702C150.779 25.0785 154.274 28.5711 158.585 28.5711Z",
    stroke: "#1E1E1E",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1737 212.38C85.1737 212.38 64.7329 258.634 64.7329 325.883C64.7329 397.479 91.9804 451.034 91.9804 451.034H139.185C139.185 451.034 166 398.046 166 325.883C166 258.062 145.325 212.38 145.325 212.38H85.1737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1737 212.38C85.1737 212.38 64.7329 258.634 64.7329 325.883C64.7329 397.479 91.9803 451.034 91.9803 451.034H139.185C139.185 451.034 166 398.046 166 325.883C166 258.062 145.325 212.38 145.325 212.38H85.1737Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2456 226.141H150.425",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2969 435.781H143.369",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1382 445.657C97.2878 445.657 98.2197 444.726 98.2197 443.577C98.2197 442.428 97.2878 441.496 96.1382 441.496C94.9886 441.496 94.0566 442.428 94.0566 443.577C94.0566 444.726 94.9886 445.657 96.1382 445.657Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.464 445.657C105.614 445.657 106.546 444.726 106.546 443.577C106.546 442.428 105.614 441.496 104.464 441.496C103.315 441.496 102.383 442.428 102.383 443.577C102.383 444.726 103.315 445.657 104.464 445.657Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8 445.657C126.95 445.657 127.882 444.726 127.882 443.577C127.882 442.428 126.95 441.496 125.8 441.496C124.651 441.496 123.719 442.428 123.719 443.577C123.719 444.726 124.651 445.657 125.8 445.657Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.126 445.657C135.276 445.657 136.208 444.726 136.208 443.577C136.208 442.428 135.276 441.496 134.126 441.496C132.977 441.496 132.045 442.428 132.045 443.577C132.045 444.726 132.977 445.657 134.126 445.657Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.131 385.164L44.2244 410.475L35.7837 472.419H44.2244L98.0115 449.282L74.131 385.164Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.139 385.164L186.045 410.475L194.491 472.419H186.045L132.258 449.282L156.139 385.164Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.721 386.849H109.626V472.419H120.721V386.849Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.132 323.444C119.587 323.444 123.198 319.835 123.198 315.383C123.198 310.931 119.587 307.322 115.132 307.322C110.678 307.322 107.066 310.931 107.066 315.383C107.066 319.835 110.678 323.444 115.132 323.444Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.132 352.567C119.587 352.567 123.198 348.958 123.198 344.506C123.198 340.054 119.587 336.445 115.132 336.445C110.678 336.445 107.066 340.054 107.066 344.506C107.066 348.958 110.678 352.567 115.132 352.567Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0156 221.512C94.1652 221.512 95.0972 220.581 95.0972 219.432C95.0972 218.283 94.1652 217.352 93.0156 217.352C91.866 217.352 90.9341 218.283 90.9341 219.432C90.9341 220.581 91.866 221.512 93.0156 221.512Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8 221.512C102.949 221.512 103.881 220.581 103.881 219.432C103.881 218.283 102.949 217.352 101.8 217.352C100.65 217.352 99.7183 218.283 99.7183 219.432C99.7183 220.581 100.65 221.512 101.8 221.512Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.589 221.512C111.739 221.512 112.671 220.581 112.671 219.432C112.671 218.283 111.739 217.352 110.589 217.352C109.44 217.352 108.508 218.283 108.508 219.432C108.508 220.581 109.44 221.512 110.589 221.512Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.378 221.512C120.528 221.512 121.46 220.581 121.46 219.432C121.46 218.283 120.528 217.352 119.378 217.352C118.229 217.352 117.297 218.283 117.297 219.432C117.297 220.581 118.229 221.512 119.378 221.512Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.168 221.512C129.318 221.512 130.25 220.581 130.25 219.432C130.25 218.283 129.318 217.352 128.168 217.352C127.018 217.352 126.086 218.283 126.086 219.432C126.086 220.581 127.018 221.512 128.168 221.512Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.957 221.512C138.107 221.512 139.039 220.581 139.039 219.432C139.039 218.283 138.107 217.352 136.957 217.352C135.807 217.352 134.875 218.283 134.875 219.432C134.875 220.581 135.807 221.512 136.957 221.512Z",
    fill: "#E8435D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.361 294.398C127.28 294.398 136.942 284.743 136.942 272.832C136.942 260.921 127.28 251.265 115.361 251.265C103.443 251.265 93.7808 260.921 93.7808 272.832C93.7808 284.743 103.443 294.398 115.361 294.398Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 471H11V474H484V471Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.868 257.401L391.978 269.097",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.97 252.279L415.77 274.298L413.314 273.778",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 376C357 376 381.617 352.853 392.42 337.859",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_2306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 485,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.8c071c4efbd1a990ba9d714e84ba960f.svg";
export { ForwardRef as ReactComponent };